export const CONSTANTE_TIPO_LANCAMENTO = [
      { label: "Boleto", data:"BOLETO" },
      { label: "Cheque", data:"CHEQUE" },
      { label: "Cartão de Crédito", data:"CARTAO_CREDITO" },
      { label: "Cartão de Débito", data:"CARTAO_DEBITO" },
      { label: "Débito em Conta", data:"DEBITO_CONTA" },
      { label: "Depósito em Conta", data:"DEPOSITO_CONTA" },
      { label: "Dinheiro", data:"DINHEIRO" },
      { label: "Transferência", data:"TRANSFERENCIA" },
      { label: "PIX", data:"PIX" },
      { label: "Não Informado", data:"NAO_INFORMADO" }
]
export const CONSTANTE_FORMA_PAGAMENTO = [      
      {label:"À Vista", data:"VISTA"},
      {label:"30 dias", data:"TRINTA_DIAS"},
      {label:"2x", data:"DUAS_X"},
      {label:"3x", data:"TRES_X"},
      {label:"4x", data:"QUATRO_X"},
      {label:"5x", data:"CINCO_X"},
      {label:"6x", data:"SEIS_X"},
      {label:"7x", data:"SETE_X"},
      {label:"8x", data:"OITO_X"},
      {label:"9x", data:"NOVE_X"},
      {label:"10x", data:"DEZ_X"},
      {label:"11x", data:"ONZE_X"},
      {label:"12x", data:"DOZE_X"},
      {label:"24x", data:"VINTE_QUATRO_X"},
      {label:"36x", data:"TRINTA_SEIS_X"}		
];
export const CONSTANTE_STATUS_CONTA = [
      {label:"Provisória", data:"PROVISORIA"},
	{label:"Aberta", data:"ABERTA"},
	{label:"Paga", data:"PAGA"},
      {label:"Cancelada", data:"CANCELADA"},
];
export const CONSTANTE_TIPO_CLIENTE = [
	{label:"PJ", data:"PJ"},
	{label:"PF", data:"PF"}
];

export const CONSTANTE_UFS = [
      {data:"AC", label:"Acre"},
      {data:"AL", label:"Alagoas"},
      {data:"AM", label:"Amazonas"},
      {data:"AP", label:"Amapá"},
      {data:"BA", label:"Bahia"},
      {data:"CE", label:"Ceará"},
      {data:"DF", label:"Distrito Federal"},
      {data:"ES", label:"Espirito Santo"},
      {data:"GO", label:"Goiás"},
      {data:"MA", label:"Maranhão"},
      {data:"MG", label:"Minas Gerais"},
      {data:"MS", label:"Mato Grosso do Sul"},
      {data:"MT", label:"Mato Grosso"},
      {data:"PA", label:"Pará"},
      {data:"PB", label:"Paraíba"},
      {data:"PE", label:"Pernambuco"},
      {data:"PI", label:"Piauí"},
      {data:"PR", label:"Paraná"},
      {data:"RJ", label:"Rio de Janeiro"},
      {data:"RN", label:"Rio Grande do Norte"},
      {data:"RO", label:"Rondônia"},
      {data:"RR", label:"Roraima"},
      {data:"RS", label:"Rio Grande do Sul"},
      {data:"SC", label:"Santa Catarina"},
      {data:"SE", label:"Sergipe"},
      {data:"SP", label:"São Paulo"},
      {data:"TO", label:"Tocantins"}
];

export const CONSTANTE_OPCAO_SIM_NAO = [	
	{label:"SIM", data:"SIM"},			
	{label:"NÃO", data:"NAO"}
];

export const CONSTANTE_OPCAO_REGRA_EMISSAO_NF = [      
      {label:"Após pagamento da fatura", data:"NO_PAGAMENTO"},
      {label:"Dez dias antes do vencimento", data:"DEZ_DIAS_ANTES_DO_VENCIMENTO"},
      {label:"Primeiro dia do mês", data:"PRIMEIRO_DIA_UTIL"},
      {label:"Não emitir NF", data:"NAO_EMITIR"}
];

export const CONSTANTE_OPCAO_REGRA_ISS = [      
      {label:"ISS Retido na Fonte", data:"ISS_RETIDO_NA_FONTE"},
      {label:"ISS a Recolher", data:"ISS_A_RECOLHER_PELO_PRESTADOR"}      
];


export const CONSTANTE_STATUS_COMPRA = [      
      {label:"Solicitada", data:"SOLICITADA"},
      {label:"Aprovada", data:"APROVADA"}      
];

export const CONSTANTES_UNIDADES_MEDIDA  =[ 
      {label:"Unidade", data:"un"},
      {label:"kg", data:"kg"},
      {label:"g", data:"g"},
      {label:"hora", data:"hora"},
      {label:"dia", data:"dia"},
      {label:"ton", data:"ton"},
      {label:"m", data:"m"},
      {label:"km", data:"km"},
      {label:"cm", data:"cm"},
      {label:"mensalidade", data:"mensalidade"}
];

export const CONSTANTES_TIPO_GRUPO_CONTA = [      
      {label:"DESPESA", data:"DESPESA"},
      {label:"RECEITA", data:"RECEITA"}
]

export const CONSTANTES_BANCO_HOMOLOGADOS = [
      {label:"Banco do Brasil", data:"001"},
      {label:"Itaú", data:"341"},
      {label:"Bradesco", data:"237"},
      {label:"Caixa Econômica", data:"104"},
      {label:"Santander", data:"353"},
      {label:"Sicredi", data:"748"},
      {label:"Sicoob", data:"756"},
      {label:"Cora", data:"403"}
];

export const CONSTANTES_BANCO = [
      {label:"Banco do Brasil", data:"001"},
      {label:"Itaú", data:"341"},
      {label:"Bradesco", data:"237"},
      {label:"Caixa Econômica", data:"104"},
      {label:"Santander", data:"353"},
      {label:"Sicredi", data:"748"},
      {label:"Sicoob", data:"756"},
      {label:"Cora", data:"403"}
];

export const CONTANTES_STATUS_INSTITUICAO = [
      {label:"ATIVO", data:"ATIVO"},
      {label:"INATIVO", data:"INATIVO"}
];

export const CONTANTES_PERFIL_USUARIO_CONCEPT = [	
      {label:"GESTOR", data:"GESTOR"},
      {label:"GESTOR EMPRESA", data:"GESTOR_EMPRESA"},
      {label:"FINANCEIRO", data:"FINANCEIRO"},
      {label:"FINANCEIRO CONTAS A RECEBER", data:"FINANCEIRO_CONTA_RECEBER"},
      {label:"FINANCEIRO CONTAS A PAGAR", data:"FINANCEIRO_CONTA_PAGAR"},
      {label:"CRM", data:"CRM"},
      {label:"CRM CONTA RECEBER", data:"CRM_CONTA_RECEBER"},
      {label:"COMPRAS", data:"COMPRAS"},
];

export const CONTANTES_PERFIL_USUARIO = [	      
      {label:"GESTOR", data:"GESTOR_EMPRESA"},
      {label:"FINANCEIRO", data:"FINANCEIRO"},
      {label:"FINANCEIRO CONTAS A RECEBER", data:"FINANCEIRO_CONTA_RECEBER"},
      {label:"FINANCEIRO CONTAS A PAGAR", data:"FINANCEIRO_CONTA_PAGAR"},
      {label:"CRM", data:"CRM"},
      {label:"CRM CONTA RECEBER", data:"CRM_CONTA_RECEBER"},
      {label:"COMPRAS", data:"COMPRAS"}
];

export const CONSTANTE_CNAES = [
      {codigo:"6311-9/00", label:"6311-9/00 - Tratamento de dados, provedores de serviços ...", data:"631190000", emiteNF: true},
	{codigo:"7733-1/00", label:"7733-1/00 - Aluguel de máquinas e equipamentos para escritórios", data:"773310000", emiteNF: false},
	{codigo:"6209-1/00", label:"6209-1/00 - Suporte técnico, manutenção ...", data:"620910000", emiteNF: true}
];